/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyWithRelations } from './companyWithRelations';
import { UserWithRelations } from './userWithRelations';
import { FolderFileWithRelations } from './folderFileWithRelations';


/**
 * (tsType: FilePermissionWithRelations, schemaOptions: { includeRelations: true })
 */
export interface FilePermissionWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    /**
     * Nivel de permiso para el archivo
     */
    permissionLevel: FilePermissionWithRelations.PermissionLevelEnum;
    fileId: string;
    userId?: number;
    companyId?: string;
    file?: FolderFileWithRelations;
    user?: UserWithRelations;
    company?: CompanyWithRelations;
}
export namespace FilePermissionWithRelations {
    export type PermissionLevelEnum = 'viewer' | 'editor';
    export const PermissionLevelEnum = {
        Viewer: 'viewer' as PermissionLevelEnum,
        Editor: 'editor' as PermissionLevelEnum
    };
}


